/* jshint esversion: 6 */
/* jshint esversion: 8 */
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAPFLgnKnd-s9cBJieyBr-8wdgsDKRNn5w",
  authDomain: "delivery-king-c74cb.firebaseapp.com",
  projectId: "delivery-king-c74cb",
  storageBucket: "delivery-king-c74cb.appspot.com",
  messagingSenderId: "634529334132",
  appId: "1:634529334132:web:7377b44bea164011022221",
  measurementId: "G-Q78DVBSXYP"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const database = getDatabase(app);

const vapidKey = "BEHhwLvhkw7urKd-6gYvjwMpRnScl_nArs2uCUQO5f5cd6q4KGpWQsT9X2f2OZgSpRXHFwxsk9z1LNQn5ADAtoM";

export const requestForToken = async () => {
  const supported = await isSupported();
  if (!supported) {
    console.warn("Firebase messaging is not supported on this browser.");
    return null;
  }

  try {
    const messaging = getMessaging(app);
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      const token = await getToken(messaging, { vapidKey });
      return token;
    } else {
      console.warn("Notification permission not granted.");
      return null;
    }

  } catch (error) {
    console.error("Error getting FCM token:", error);
    return null;
  }
};

export { db, auth, database };
